import { Box, GlobalStyles, Grid, Paper, Typography } from "@mui/material";
import { useContext, useEffect } from "react";
import { DependentsForm } from "../components/DependentsForm";
import { ArrowButon } from "../components/ArrowButton";
import { AppContext } from "../context";
import { useWindowDimensions } from "../hooks/useWindowDimensions";

export const DependentsPage = () => {
  const { plan, logo, lead, theme, backgroundImage } =
    useContext<any>(AppContext);
  const { width } = useWindowDimensions();
  const background = theme ? theme.palette.background.default : "#fff";

  // useEffect(() => {
  //   updateEvent({ type: "MQL", leadId: lead.leadId });
  // }, []);

  return (
    <Box
      sx={{
        maxHeight: "100vh",
        width: "80vw",
        maxWidth: "1500px",
        margin: "auto",
        paddingTop: "10px",
      }}
    >
      <GlobalStyles
        styles={{
          body: {
            backgroundColor: `${background}`,
            padding: "5px",
            maxHeight: "100vh",
          },
        }}
      />
      <Paper
        sx={{
          my: "auto",
          maxHeight: 650,
          backgroundColor: "background.default",
          boxShadow: 0,
        }}
      >
        <Grid container>
          <Grid
            item
            xl={8}
            md={8}
            sm={12}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-evenly",
              mb: width > 400 ? 0 : 2,
            }}
          >
            <Box
              sx={{
                pl: width > 400 ? 8 : 3,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                mb: width > 400 ? 1 : 2,
              }}
            >
              <Box>
                <img
                  src={logo}
                  alt=""
                  style={{ width: width > 400 ? theme.subAccountLogoWidth : '110px', marginBottom: '20px' }}
                />
              </Box>
              <Box
                sx={{
                  position: "absolute",
                  top: 20,
                  left: 0,
                }}
              >
                <ArrowButon path="/endereco" />
              </Box>
              <Box>
                <Typography
                  sx={{
                    color: "primary.main",
                    fontSize: "1.8rem",
                    // fontWeight: 'bold',
                    fontFamily: 'Montserrat'
                  }}
                >
                  Quase lá!
                </Typography>
                <Typography sx={{ color: "primary.main", fontSize: "1.2rem", fontFamily: 'Montserrat' }}>
                  Informe os dados dos dependentes <br /> para concluir seu
                  cadastro.
                </Typography>
              </Box>
              <Box sx={{ mt: 3 }}>
                <Typography
                  sx={{ color: "secondary.main", fontSize: "1.8rem", fontFamily: 'Montserrat' }}
                >
                  Plano selecionado:
                </Typography>
                <Typography
                  sx={{ color: "secondary.main", fontSize: "1.2rem", fontFamily: 'Montserrat' }}
                >
                  <strong>{plan.plan_selected}:</strong> R$ {plan.price}
                </Typography>
                {plan.product_description && (
                  <Typography
                    sx={{ color: "secondary.main", fontSize: "1.2rem", fontFamily: 'Montserrat' }}
                  >
                    {plan.product_description}
                  </Typography>
                )}
              </Box>
            </Box>
            <Box sx={{ m: "0 auto", width: "100%" }}>
              <DependentsForm />
            </Box>
          </Grid>
          {width > 1000 && (
            <Grid item>
              <Box
                sx={{
                  maxHeight: "100%",
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <img src={backgroundImage} width="350px" alt="" />
              </Box>
            </Grid>
          )}
        </Grid>
      </Paper>
    </Box>
  );
};
